/** Samples hit every peak and valley; scallops use a smooth cosine wave instead of sharp sawteeth. */
export function toothedBandSamples(profile) {
    const toothCount = Math.max(1, Math.round(profile.toothCount));
    const samplesPerTooth = 2 * Math.max(profile.edgeProfile === 'scalloped' ? 8 : 1, Math.ceil(Math.max(1, profile.segments) / (2 * toothCount)));
    const total = toothCount * samplesPerTooth;
    const { innerRadius, outerRadius, halfHeight, toothDepth } = profile;
    return Array.from({ length: total + 1 }, (_, index) => {
        const phase = (index % samplesPerTooth) / samplesPerTooth;
        const lift = toothDepth * (profile.edgeProfile === 'scalloped'
            ? (1 - Math.cos(phase * Math.PI * 2)) / 2 : 1 - Math.abs(2 * phase - 1));
        const radialLift = profile.toothAxis === 'radial' ? lift : 0;
        const axialLift = profile.toothAxis === 'axial' ? lift : 0;
        const inner = innerRadius - radialLift, outer = outerRadius + radialLift;
        const bottom = -halfHeight - axialLift, top = halfHeight + axialLift;
        return {
            angle: (index / total) * Math.PI * 2,
            corners: [[inner, bottom], [outer, bottom], [outer, top], [inner, top]],
        };
    });
}
export function toothedBandMaxRadius(profile) {
    return profile.outerRadius + (profile.toothAxis === 'radial' ? profile.toothDepth : 0);
}
export function toothedBandMaxHalfHeight(profile) {
    return profile.halfHeight + (profile.toothAxis === 'axial' ? profile.toothDepth : 0);
}
